import React from 'react';
import moment from 'moment';
import {
  ProspectActivity,
  BlastengineAutomaticMailSendMailClickProspectActivity,
} from 'api';
import {AutomaticMail} from 'components/Ui/Icon';

interface BlastengineAutomaticMailSendMailClickActivity
  extends ProspectActivity {
  resource: BlastengineAutomaticMailSendMailClickProspectActivity;
}

interface Props {
  prospectActivity: BlastengineAutomaticMailSendMailClickActivity;
}

export default ({prospectActivity}: Props) => {
  const {
    resource: {
      automaticMailSend = {},
      automaticMailUrl = {},
      automaticMailSendShortUrl = {},
    } = {},
  } = prospectActivity;

  const url =
    automaticMailSendShortUrl?.urlPlaceholder || automaticMailUrl?.url;

  return (
    <>
      <AutomaticMail active={true} width="32" height="32" />
      <div className="flex-1 ml-2.5">
        <div className="flex items-center min-h-[30px]">
          <h3 className="flex-1 m-0 text-c-primary font-bold">
            {automaticMailSend?.step?.name}
          </h3>
          <time className="ml-[15px] text-gray-600">
            {moment(prospectActivity.createdAt).format('YYYY/MM/DD HH:mm')}
          </time>
        </div>
        <div className="flex w-full text-gray-600">
          <a
            href={url}
            target="_blank"
            className="overflow-hidden max-w-md whitespace-nowrap text-ellipsis">
            {url}
          </a>
        </div>
      </div>
    </>
  );
};
